import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Init from "../Init.vue";
import Welcome from "../components/welcome/Welcome.vue";
import WelcomeMobile from "../components/welcome/WelcomeMobile.vue";
import Main from "../Main.vue";
import MainMobile from "../MainMobile.vue";
import WaitingMobile from "../WaitingMobile.vue";
import Experience from "../components/experience/Experience.vue";
import ExperienceMobile from "../components/experience/ExperienceMobile.vue";
import Formation from "../components/formation/Formation.vue";
import Competences from "../components/competences/Competences.vue";
import Hobbies from "../components/hobbies/Hobbies.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/welcome",
    name: "Welcome",
    component: Welcome
  },
  {
    path: "/welcomeMobile",
    name: "WelcomeMobile",
    component: WelcomeMobile
  },
  {
    path: "/experience",
    name: "Experience",
    component: Experience
  },
  {
    path: "/experienceMobile",
    name: "ExperienceMobile",
    component: ExperienceMobile
  },
  {
    path: "/formation",
    name: "Formation",
    component: Formation
  },
  {
    path: "/competences",
    name: "Competences",
    component: Competences
  },
  {
    path: "/hobbies",
    name: "Hobbies",
    component: Hobbies
  },
  {
    path: "/",
    name: "Root",
    component: Init
  },
  {
    path: "/main",
    name: "Main",
    component: Main
  },
  {
    path: "/mainMobile",
    name: "MainMobile",
    component: MainMobile
  },
  {
    path: "/waitingMobile",
    name: "WaitingMobile",
    component: WaitingMobile
  }
];

const router = new VueRouter({
  routes
});

export default router;
